<template>
  <div class="orientation-wrapper">
    <!-- <p>Please, turn your device landscape.</p> -->
    <img src="/static/orientation.jpg" alt="">
  </div>
</template>

<script>
export default {
  name: 'Orientation',

}
</script>

<style lang="scss" scoped>

.orientation-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    text-align: center;
    max-width: 70%;
    z-index: 1;
  }

  img {
    width: 70%;
    max-width: 400px;
    animation: rotate 0.5s 0.8s forwards;

    @keyframes rotate {
      0% {
        transform: rotateZ(0deg);
      }
      100% {
        transform: rotateZ(-90deg);
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Orientation.vue